// Determine API URL based on environment
const getApiUrl = (): string => {
  // Check for explicit environment variable first
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // Check if we're in production
  if (process.env.NODE_ENV === 'production') {
    // Production URL for Hostinger deployment
    return 'http://www.service.opinloop.com';
  }
  
  // Default to localhost for development
  return 'http://localhost:3001';
};

export const OPINION_SERVICE_HOST = getApiUrl();
export const OPINIONS_API_PREFIX = '/opinloop-core/v1';
